import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../../types";
import { getApi } from "../../../apiPath";
import { axiosClient } from "../../../clients";

import type { ILaboratoryProjects } from "./routeType";

const { key, getPath } = getApi("members.laboratories.projects.getAll");

type IExtractedRouteType =
  ILaboratoryProjects["laboratoryProjectCollectionRetrieve"];

export type IGetAllMemberLaboratoryProjects =
  IPickCollectionQuery<IExtractedRouteType>;

const getAllMemberLaboratoryProjects: Fetcher<
  IGetAllMemberLaboratoryProjects["response"],
  IGetAllMemberLaboratoryProjects["variables"]
> = ({ labId, ...params }) => {
  return axiosClient.get(getPath({ labId }), { params });
};

export const useGetAllMemberLaboratoryProjects = createQuery({
  queryKey: [key],
  fetcher: getAllMemberLaboratoryProjects,
});
